import React from "react";
import { Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { faqs } from "../../data/data";
import "./Faqs.scss";

const Faqs = () => {
  const expandIcon = ({ isActive }) => (
    <div className="faq__icon">
      <DownOutlined rotate={isActive ? 180 : 0} />
    </div>
  );

  return (
    <section id="faqs" className="faq">
      <div className="faq__container">
        <div className="faq__title">Pricing FAQs</div>
        <Collapse
          expandIconPosition="right"
          className="faq__list"
          bordered={false}
          expandIcon={expandIcon}
        >
          {faqs.map((item, index) => (
            <Collapse.Panel
              key={index}
              header={<span className="faq__question">{item.question}</span>}
              className="faq__item"
            >
              <div className="faq__answer">{item.answer}</div>
            </Collapse.Panel>
          ))}
        </Collapse>
      </div>
    </section>
  );
};

export default Faqs;
